import React, { Component } from 'react';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { injectIntl, defineMessages } from 'react-intl';

import { Image } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './StartExam.css';
const cx = classNames.bind(styles);

class StartExamWizardHeader extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { step } = this.props;

    let StepComponent = (
      <div className={cx('start-exam-wizard-header-box')}>
        <div className={cx('step-area')}>
          <div className={cx('step-info')}>
            <div className={cx('step')}>
              {defineMessages(formatMessage({ id: 'StartExamWizardHeader_1', defaultMessage: '환경 검사' }))}
            </div>
            <div className={cx('step-explain')}>
              {defineMessages(
                formatMessage({
                  id: 'StartExamWizardHeader_6',
                  defaultMessage: '훈련이 원활하게 수행될 수 있도록 관련 설정을 검사합니다.'
                })
              )}
            </div>
          </div>
        </div>
        <div className={cx('step-progress')}>
          <Image src={'/img/examStart/step' + step + '.png'} />
        </div>
      </div>
    );
    if (step === 2) {
      StepComponent = (
        <div className={cx('start-exam-wizard-header-box')}>
          <div className={cx('step-area')}>
            <div className={cx('step-info')}>
              <div className={cx('step')}>
                {defineMessages(formatMessage({ id: 'StartExamWizardHeader_2', defaultMessage: '일반 설정' }))}
              </div>
              <div className={cx('step-explain')}>
                {ReactHtmlParser(
                  defineMessages(
                    formatMessage({
                      id: 'StartExamWizardHeader_7',
                      defaultMessage:
                        "<div class='explain-content'><div class='explain-strong'>훈련명 및 훈련기간</div>을 입력합니다.</div>"
                    })
                  )
                )}
              </div>
            </div>
          </div>
          <div className={cx('step-progress')}>
            <Image src={'/img/examStart/step' + step + '.png'} />
          </div>
        </div>
      );
    } else if (step === 3) {
      StepComponent = (
        <div className={cx('start-exam-wizard-header-box')}>
          <div className={cx('step-area')}>
            <div className={cx('step-info')}>
              <div className={cx('step')}>
                {defineMessages(formatMessage({ id: 'StartExamWizardHeader_3', defaultMessage: '대상자 지정' }))}
              </div>
              <div className={cx('step-explain')}>
                {ReactHtmlParser(
                  defineMessages(
                    formatMessage({
                      id: 'StartExamWizardHeader_8',
                      defaultMessage:
                        "<div class='explain-content'><div class='explain-strong'>태그</div>를 입력하여 훈련 대상자를 지정합니다.</div>"
                    })
                  )
                )}
              </div>
            </div>
          </div>
          <div className={cx('step-progress')}>
            <Image src={'/img/examStart/step' + step + '.png'} />
          </div>
        </div>
      );
    } else if (step === 4) {
      StepComponent = (
        <div className={cx('start-exam-wizard-header-box')}>
          <div className={cx('step-area')}>
            <div className={cx('step-info')}>
              <div className={cx('step')}>
                {defineMessages(formatMessage({ id: 'StartExamWizardHeader_4', defaultMessage: '훈련 양식' }))}
              </div>
              <div className={cx('step-explain')}>
                {ReactHtmlParser(
                  defineMessages(
                    formatMessage({
                      id: 'StartExamWizardHeader_9',
                      defaultMessage:
                        "<div class='explain-content'><div class='explain-strong'>훈련 양식(메일 내용 및 첨부 종류 등)</div>을 선택합니다.</div>"
                    })
                  )
                )}
              </div>
            </div>
          </div>
          <div className={cx('step-progress')}>
            <Image src={'/img/examStart/step' + step + '.png'} />
          </div>
        </div>
      );
    } else if (step === 5) {
      const { examFail, examResultData } = this.props;

      let resultTitle = null;
      if (examFail) {
        // 훈련 실행 요청되기 전에 오류가 발견됨
        resultTitle = ReactHtmlParser(
          defineMessages(formatMessage({ id: 'StartExamWizardContent_49', defaultMessage: '오류가 발생하였습니다.' }))
        );
      } else {
        if (examResultData) {
          if (examResultData.result === 1 && examResultData.success) {
            // 훈련 실행 요청이 전달되고 정상적으로 처리됨
            resultTitle = ReactHtmlParser(
              defineMessages(
                formatMessage({
                  id: 'StartExamWizardHeader_10',
                  defaultMessage:
                    "훈련 실행이 <div class='complate-back'><span class='text'>완료</span><span class='area' /></div>되었습니다."
                })
              )
            );
          } else if (examResultData.result === 0 && examResultData.error && Array.isArray(examResultData.error)) {
            // 훈련 실행 요청이 전달되었으나 오류가 반환됨
            resultTitle = ReactHtmlParser(
              defineMessages(
                formatMessage({
                  id: 'StartExamWizardContent_59',
                  defaultMessage: '오류가 발생하여 훈련이 실행되지 않았습니다.'
                })
              )
            );
          }
        } else {
          // ?
        }
      }

      StepComponent = (
        <div className={cx('start-exam-wizard-header-box complate')}>
          <div className={cx('start-exam-complate-image')}>
            <Image src={'/img/examStart/step' + step + '.png'} />
          </div>
          <div className={cx('start-exam-complate-text')}>{resultTitle}</div>
        </div>
      );
    }

    return StepComponent;
  }
}
StartExamWizardHeader.propTypes = {
  step: PropTypes.number
};
StartExamWizardHeader.defaultProps = {
  step: 1
};

export default injectIntl(StartExamWizardHeader);



// WEBPACK FOOTER //
// ./src/script/components/exam-start/StartExamWizardHeader.js